import i18n from "@config/i18n";

const GROUP_TYPE_LABELS = {
  NATIONAL: "groups-manager.groups-table.table.rows.group-type.national-type",
  CAMPUS: "groups-manager.groups-table.table.rows.group-type.campus-type",
  PACKAGE: "groups-manager.groups-table.table.rows.group-type.package-type",
  SHARED: "groups-manager.groups-table.table.rows.group-type.shared-type",
};

export const getGroupTypeLabel = (groupType: string) => {
  if (groupType && groupType in GROUP_TYPE_LABELS) {
    return i18n.t(GROUP_TYPE_LABELS[groupType as keyof typeof GROUP_TYPE_LABELS]);
  }

  return "";
};
